import { LoyaltyAutocheck } from "@redotech/redo-loyalty-common/loyalty-autocheck";
import { InsertionPosition } from "@redotech/redo-loyalty-common/widget-types";
import { useMemo } from "react";
import { log } from "../../../monitoring/log";
import { RedoLoyaltyContainerElement } from "./element";

const positionMap: Record<InsertionPosition, InsertPosition> = {
  [InsertionPosition.BEFORE]: "beforebegin",
  [InsertionPosition.AFTER]: "afterend",
  [InsertionPosition.PREPEND]: "afterbegin",
  [InsertionPosition.APPEND]: "beforeend",
};

interface LoyaltyPortal {
  foundSelector?: string;
  portal: RedoLoyaltyContainerElement;
}

export function useRenderEmbeddings({
  loyaltySettings,
}: {
  loyaltySettings: LoyaltyAutocheck;
}): LoyaltyPortal[] {
  const renderEmbeddings = useMemo(() => {
    const portals: LoyaltyPortal[] = [];

    if (
      !loyaltySettings.enabled ||
      !loyaltySettings.storefrontEmbedding.enabled
    ) {
      return portals;
    }

    const selector = loyaltySettings.storefrontEmbedding.selector;
    log("loyalty embedding selector", selector);
    const containers = document.querySelectorAll(selector);
    log("loyalty embedding containers", containers);

    // Register the custom element if not already registered
    RedoLoyaltyContainerElement.register();

    for (const container of containers) {
      const loyaltyElement = document.createElement(
        RedoLoyaltyContainerElement.TAG,
      ) as RedoLoyaltyContainerElement;
      loyaltyElement.id = "redo-loyalty-container";
      // This is needed to ensure the element is displayed, Shopify has a CSS
      // rule that hides empty divs, and this div is considered empty because
      // it only contains the shadow root.
      loyaltyElement.style.display = "unset !important";

      const insertPosition =
        positionMap[loyaltySettings.storefrontEmbedding.insertPosition];
      container.insertAdjacentElement(insertPosition, loyaltyElement);

      const matchingSelector = selector
        .split(",")
        .find((sel) => container.matches(sel));

      portals.push({ foundSelector: matchingSelector, portal: loyaltyElement });
    }

    return portals;
  }, [loyaltySettings]);

  return renderEmbeddings;
}
